export const ArrowRightIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 8 12"
      width="8px"
      height="8px"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.861278 0.195262C1.12163 -0.0650874 1.54374 -0.0650874 1.80409 0.195262L7.13742 5.5286C7.39777 5.78895 7.39777 6.21106 7.13742 6.4714L1.80409 11.8047C1.54374 12.0651 1.12163 12.0651 0.861278 11.8047C0.600928 11.5444 0.600928 11.1223 0.861278 10.8619L5.72321 6L0.861278 1.13807C0.600928 0.877722 0.600928 0.455612 0.861278 0.195262Z"
        fill="currentColor"
      />
    </svg>
  );
};
